<script lang="ts">
    import type {LocalizeFunction} from '../../svelte/types';
    import {getContext} from 'svelte';
    import {INJECTOR_KEY, LOCALIZE_KEY} from '../../svelte/utils';
    import KpResponsiveGenericTable from '../../commons/ui-components/table/KpResponsiveGenericTable.svelte';
    import type {Injector} from '../../svelte/types';
    import KpLoadingBlock from '../../commons/components/kp-loading/KpLoadingBlock.svelte';
    import {KpLoanCategoriesPresenter} from './kp-loan-categories.presenter';

    const localize: LocalizeFunction = getContext(LOCALIZE_KEY);
    const injector: Injector = getContext(INJECTOR_KEY);
    const presenter: KpLoanCategoriesPresenter = injector.getByToken(KpLoanCategoriesPresenter.presenterName);
</script>

<h1>{localize(/* @kp-localization commons.LoanCategories */ 'commons.LoanCategories')}</h1>

<KpResponsiveGenericTable hoverRows={true}>
    <slot slot="header">
        <tr>
            <th>#</th>
            <th>{localize( /* @kp-localization commons.nazev */ 'commons.nazev')}</th>
            <th>Půjčování</th>
            <th>Rezervace</th>
            <th>Prezenční</th>
            <th>Prolongace</th>
            <th>Upomínky</th>
            <th>K cirkulaci</th>
            <th>K dislokaci</th>
            <th>Titulová</th>
            <th>Okamžité vracení</th>
        </tr>
    </slot>
    <slot slot="body">
        {#await presenter.getAll()}
            <KpLoadingBlock/>
        {:then loanCategories}
            {#each loanCategories as lc (lc.id)}
                <tr>
                    <td>{lc.id}</td>
                    <td>
                        <span>{lc.name}</span>
                        <br/>
                        <span class="text-muted">({lc.text})</span>
                    </td>
                    <td><span class:hidden={!lc.lendable} class="glyphicon glyphicon-ok"></span></td>
                    <td><span class:hidden={!lc.reservable} class="glyphicon glyphicon-ok"></span></td>
                    <td><span class:hidden={!lc.inPlace} class="glyphicon glyphicon-ok"></span></td>
                    <td><span class:hidden={!lc.renewable} class="glyphicon glyphicon-ok"></span></td>
                    <td><span class:hidden={!lc.reminderable} class="glyphicon glyphicon-ok"></span></td>
                    <td><span class:hidden={!lc.circular} class="glyphicon glyphicon-ok"></span></td>
                    <td><span class:hidden={!lc.forDislocation} class="glyphicon glyphicon-ok"></span></td>
                    <td><span class:hidden={!lc.chunkable} class="glyphicon glyphicon-ok"></span></td>
                    <td><span class:hidden={!lc.returningImmediately} class="glyphicon glyphicon-ok"></span></td>
                </tr>
            {/each}
        {/await}
    </slot>
</KpResponsiveGenericTable>